import Vue from 'vue'
import store from './store'
import _ from 'lodash'
import moment from 'moment';
Vue.filter('currentyCodeToSymbol', function (value, code) {
  var symbols = {GBP: '£', USD: '$', EUR: '€', AUD: 'A$', CAD: 'CA$', ZAR: 'R'}
  var sym = symbols[code]
  if (!value) { value = 0 }
  return sym + `${value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
})
Vue.filter('priceLabelToSymbol', function (value, code) {
  var symbols = {TEFLORG: '£', TEFLUS: '$', IRELAND: '€', AUSTRALIA: 'A$', CANADA: 'CA$', SOUTHAFRICA: 'R', undefined: '£'}
  var sym = symbols[code]
  if (!value) { value = 0 }
  return sym + `${value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
})
Vue.filter('time', function (value) {
  return value? value.substring(0,5) :''
})
Vue.filter('niceStatus', function (code) {
  var symbols = {0: 'Pending', 1: 'Deposit Paid', 2: 'Fully Paid', 4: 'Cancelled'}
  var sym = symbols[code]
  return sym
})
Vue.filter('niceRegion', function (code) {
  var symbols = {ALL: 'All regions', TEFLORG: 'The UK', TEFLUS: 'The US', IRELAND: 'Ireland', AUSTRALIA: 'Australia', CANADA: 'Canada', SOUTHAFRICA: 'South Africa'}
  var sym = symbols[code]
  return sym
})
Vue.filter('regionToFlag', function (code) {
  var symbols = {ALL: 'All', TEFLORG: 'static/img/flags/UK.png', TEFLUS: 'static/img/flags/US.png', IRELAND: 'static/img/flags/EU.png', AUSTRALIA: 'static/img/flags/AU.png', CANADA: 'static/img/flags/CA.png', SOUTHAFRICA: 'static/img/flags/ZA.png'}
  var sym = symbols[code]
  return sym
})
Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  })
  return formatter.format(value)
})
Vue.filter('userById', function (value, users) {
  var g = _.find(store.getters.getUsers, {id: parseInt(value)})
  if (g) { return g.longname } else { return 'Customer' }
})
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('codeToCurrency', function (value) {
  if (value === 'GBP') return '£'
  if (value === 'USD') return '$'
  if (value === 'EUR') return 'Ꞓ'
  if (value === 'AUD') return 'A$'
  if (value === 'CAD') return 'CA$'
  if (value === 'ZAR') return 'R'
})
Vue.filter('labelToCurrency', function (value) {
  if (value === 'TEFLORG') return 'Pounds (£)'
  if (value === 'TELUS') return 'Dollar ($)'
  if (value === 'IRELAND') return 'Euro (Ꞓ)'
  if (value === 'AUSTRALIA') return 'AUD (A$)'
  if (value === 'CANADA') return 'CAD (CA$)'
  if (value === 'SOUTHAFRICA') return 'ZAR (R)'
})
Vue.filter('orderStatus', function (value) {
  if (value === '0') return 'pending'
  if (value === '1') return 'deposit'
  if (value === '2') return 'fully'
})
Vue.filter('venue', function (value) {
  return value.split('-')[1]
})
Vue.filter('town', function (value) {
  return value.split('-')[2].slice(0, -4)
})
Vue.filter('expiryDate', function (value) {
  var g = _.find(value, function (o) { return o.key === 'expiryDate' })
  return g.value
})

Vue.filter('learnerAgreement', function (value) {
  var g = _.find(value, function (o) { return o.key === 'signedLearnerAgreement' })
  if (g.value === 1) { return true } else { return false }
})

Vue.filter('correctTime', function (value) {
return value?moment(value).utc().format('ha'):'';
})



// WEBPACK FOOTER //
// ./src/filters.js